import {
    Box,
    Typography,
    Stack,
    Link
} from "@mui/material";
import { Telegram, Twitter } from "@mui/icons-material";

const Footer = () => {
    return <Box component="footer" sx={{ py: 5 }}>
        <Stack
            direction="row"
            justifyContent="center"
            spacing={4}
            sx={{ mb: 5 }}
        >
            <Link
                sx={{ textDecoration: "none" }}
                href="https://t.me/bakebean_XYZ"
                target="_blank"
                rel="noopener noreferrer"
            >
                <Telegram fontSize="large" htmlColor="#12a69c" />
            </Link>
            <Link
                sx={{ textDecoration: "none" }}
                href="https://t.me/bakebean_CHAT"
                target="_blank"
                rel="noopener noreferrer"
            >
                <Telegram fontSize="large" htmlColor="#12a69c" />
            </Link>
            <Link
                sx={{ textDecoration: "none" }}
                href="https://twitter.com/bakebean_XYZ"
                target="_blank"
                rel="noopener noreferrer"
            >
                <Twitter fontSize="large" htmlColor="#12a69c" />
            </Link>
        </Stack>
        <Typography align="center">
            Build with ♥ by Uncle Bean
        </Typography>
    </Box>;
};

export default Footer;